import { Link } from 'react-router-dom';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import LatestSection from '@/pages/home/components/LatestSection';
import HotSection from '@/pages/home/components/HotSection';
import NewsBrief from '@/pages/home/components/NewsBrief';
import SpecialFeature from '@/pages/home/components/SpecialFeature';
import HistoryPanel from '@/pages/home/components/HistoryPanel';

const quickEntries = [
  { to: '/category/movie', icon: 'ri-film-line', label: '电影专区', desc: '动作 · 科幻 · 爱情' },
  { to: '/category/tv', icon: 'ri-tv-2-line', label: '热播剧集', desc: '连载 · 完结 · 全集' },
  { to: '/news', icon: 'ri-newspaper-line', label: '影视资讯', desc: '行业动态 · 快讯' },
  { to: '/special', icon: 'ri-gallery-view-2', label: '专题合集', desc: '精选主题 · 一网打尽' },
];

export default function Home() {
  return (
    <div className="w-full">
      <HeroCarousel />

      <div className="mx-auto w-full px-4 md:px-6">
        <div className="mt-6 mb-10 grid grid-cols-2 gap-3 md:mt-8 md:grid-cols-4 md:gap-4">
          {quickEntries.map((entry) => (
            <Link
              key={entry.to}
              to={entry.to}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 md:p-4"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <span className="min-w-0">
                <span className="block whitespace-nowrap text-sm font-bold text-foreground-950">{entry.label}</span>
                <span className="block truncate text-xs text-foreground-500">{entry.desc}</span>
              </span>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="flex flex-col gap-10 lg:col-span-2">
            <LatestSection />
            <HotSection />
          </div>
          <aside className="flex flex-col gap-6">
            <NewsBrief />
            <SpecialFeature />
            <HistoryPanel />
          </aside>
        </div>

        <section className="mt-14 rounded-lg border border-primary-200 bg-primary-50 p-6 animate-fade-up md:p-10">
          <div className="flex flex-col items-center gap-4 text-center md:flex-row md:justify-between md:text-left">
            <div>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">发现属于你的下一部好剧</h2>
              <p className="mt-2 text-sm text-foreground-600 md:text-base">
                樱花视频汇聚最新电影、热播剧集与深度资讯，陪你度过每一个追剧夜晚。
              </p>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <Link
                to="/category/movie"
                className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
              >
                浏览电影
              </Link>
              <Link
                to="/category/tv"
                className="whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-primary-700 hover:bg-primary-100"
              >
                浏览剧集
              </Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}